export const passwordRequirementHintTexts: string[] = [
    "Length should be between 8 and 512.",
    "Must contain at least 1 digit (0 - 9)."
];

export default passwordRequirementHintTexts;
